import styled from 'styled-components'

export const VideoWrapper = styled.div`
  ${props => {
    if (props.background) {
      return `
        position: absolute;
        inset: 0;
        overflow: hidden;`
    }
  }}
`

export const VideoPlayer = styled.video`
  ${props =>
    props.background &&
    `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: none;
    `}
  display: block;
`
